import {BaseSearchDTO} from "../baseSearchDTO.interface";

export interface VehicleFaultCheckTypeSearchDTO extends BaseSearchDTO {
  filters?: {
  };
}
